import React, { useEffect, useRef } from "react";
import { Form, FormInstance, Input, Modal, Radio } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

export interface IVehicleActionProps {
  formVehicleActionAttendance: FormInstance;
  vehicleActionSelected: number;
  allowRequestDockEntryAction: boolean;
  disabledButtonSaveVehicle: boolean;
  allowRequestVehicleInboundAction: boolean;
  visibleModalVehicleAction: boolean;
  setVehicleActionSelected: (...args) => void;
  onChangeRadioVehicleAction: (...args) => void;
  handleClickConfirmVehicleAction: (...args) => void;
  attendanceHideModalVehicleAction: (...args) => void;
}

const VehicleAction = ({
  formVehicleActionAttendance,
  vehicleActionSelected,
  allowRequestDockEntryAction,
  allowRequestVehicleInboundAction,
  visibleModalVehicleAction,
  disabledButtonSaveVehicle,
  setVehicleActionSelected,
  onChangeRadioVehicleAction,
  handleClickConfirmVehicleAction,
  attendanceHideModalVehicleAction,
}: IVehicleActionProps): JSX.Element => {
  const inputDock = useRef(null);
  const LOBBY = useTranslation({ id: "lobby" });
  const DOCK = useTranslation({ id: "dock" });
  const CALL_VEHICLE_TO_LOBBY_TITLE = useTranslation({ id: "call_vehicle_to_lobby_description" });
  const DRIVER_WARNING_TITLE = useTranslation({ id: "driver_warning_description" });
  const INFORM_DOCK_ADDRESS = useTranslation({ id: "inform_dock_address" });
  const REQUIRED_FIELD = useTranslation({ id: "required_field" });
  const ADDRESS = useTranslation({ id: "address" });
  const attendanceRadioSelected = 1;

  useEffect(() => {
    if (!allowRequestVehicleInboundAction && allowRequestDockEntryAction) {
      setVehicleActionSelected(2);
    }
  }, [allowRequestVehicleInboundAction, allowRequestDockEntryAction, vehicleActionSelected]);

  useEffect(() => {
    if (inputDock && inputDock.current) {
      const { input } = inputDock.current;
      input.focus();
    }
  });

  return (
    <Form style={S.FormLayout} layout={"vertical"} form={formVehicleActionAttendance} name="vehicleActionAttendance">
      <S.VehicleActionContainer>
        <Modal
          title={useTranslation({ id: "call_driver" })}
          centered
          bodyStyle={{ height: "270px" }}
          maskClosable={false}
          open={visibleModalVehicleAction}
          confirmLoading={disabledButtonSaveVehicle}
          onOk={() => handleClickConfirmVehicleAction()}
          onCancel={() => attendanceHideModalVehicleAction()}
          okText={useTranslation({ id: "confirm" })}
          cancelText={useTranslation({ id: "cancel" })}
        >
          <S.DescriptionVehicleAction>{useTranslation({ id: "select_vehicle_action_description" })}</S.DescriptionVehicleAction>
          <S.RadioContainer>
            <Radio.Group
              style={allowRequestDockEntryAction && allowRequestVehicleInboundAction ? S.RadioGroup : S.RadioOnlyOption}
              value={vehicleActionSelected}
              onChange={onChangeRadioVehicleAction}
            >
              {allowRequestVehicleInboundAction && (
                <Radio className="radioButton" value={1}>
                  {LOBBY}
                </Radio>
              )}
              {allowRequestDockEntryAction && (
                <Radio className="radioButton" value={2}>
                  {DOCK}
                </Radio>
              )}
            </Radio.Group>
          </S.RadioContainer>
          {vehicleActionSelected === attendanceRadioSelected ? (
            <S.DescriptionVehicleActionContainer>
              <S.DescriptionVehicleAction>{CALL_VEHICLE_TO_LOBBY_TITLE}</S.DescriptionVehicleAction>
              <S.DescriptionVehicleAction>{DRIVER_WARNING_TITLE}</S.DescriptionVehicleAction>
            </S.DescriptionVehicleActionContainer>
          ) : (
            <div>
              <S.FormItem
                name="dockAttendance"
                label={`${INFORM_DOCK_ADDRESS}*`}
                rules={[
                  {
                    required: true,
                    message: REQUIRED_FIELD,
                  },
                ]}
              >
                <Input style={S.DockDescriptionField} placeholder={ADDRESS} maxLength={20} ref={inputDock} autoFocus />
              </S.FormItem>
              <S.DriverWarningDescription>{DRIVER_WARNING_TITLE}</S.DriverWarningDescription>
            </div>
          )}
        </Modal>
      </S.VehicleActionContainer>
    </Form>
  );
};

export default VehicleAction;
